/*
 * Author: Dw
 * File Created: Tuesday, 25-06-10 11:25 am
 * Last Modified: Tuesday, 25-06-10 01:48 pm, by Dw
 */

import { sleep } from './promise';

export class TaskQueue<T = unknown> {
  private queue: Array<() => Promise<T>> = [];
  private isRunning = false;
  private delay: number;

  constructor(delay = 1000) {
    this.delay = delay;
  }

  push(task: () => Promise<T>): void {
    this.queue.push(task);
  }

  async execute(): Promise<void> {
    if (this.isRunning) return;
    this.isRunning = true;

    while (this.queue.length > 0) {
      const task = this.queue.shift();
      try {
        await task?.();
      } catch (err) {
        console.error('DialogQueue execute failed: ', err);
      }
      await sleep(this.delay);
    }

    this.isRunning = false;
  }
}
